import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../../services/payment.service';
import { HelpersService } from '../../../../services/helpers.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-paystack-integration-configuration',
  templateUrl: './paystack-integration-configuration.component.html',
  styleUrls: ['./paystack-integration-configuration.component.scss'],
})
export class PaystackIntegrationConfigurationComponent implements OnInit {
  public linkedToPaystack: boolean = false;
  public paystackSecretKey: string = '';
  public busy: boolean = false;
  public isRentals = false;
  public isWorkshop = true;

  constructor(
    private paymentService: PaymentService,
    private helpersService: HelpersService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getPartnerPaystackConfig();
    if ( this.router.url.toLocaleLowerCase() === '/store/rentals/paystack-configuration') {
      this.isRentals = true;
      this.isWorkshop = false;
    }
  }

  getPartnerPaystackConfig() {
    this.busy = true;
    this.paymentService
      .getPartnerPaystackConfig(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          if (config.linked) {
            this.paystackSecretKey = config.paystackSecretKey;
            this.linkedToPaystack = true;
          } else {
            this.paystackSecretKey = '';
            this.linkedToPaystack = false;
          }
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  linkPaystackAccount() {
    this.busy = true;
    this.paymentService
      .updatePartnerPaystackConfig(
        this.helpersService.getPartnerId(),
        this.paystackSecretKey,
      )
      .subscribe(
        (res) => {
          this.linkedToPaystack = true;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  disconnectPaystackAccount() {
    this.busy = true;
    this.paymentService
      .deletePartnerPaystackConfig(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.linkedToPaystack = false;
          this.paystackSecretKey = '';
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }
}
